import Request from 'gd-request';

class ApiCompanyApiV2 {

    constructor() {
    }

    getToken(companyId) {
        return new Request(this,'GET','company/'+gd.companyId+'/admin/api_2_0');
    }

    issueToken() {
        return new Request(this,'POST','company/'+gd.companyId+'/admin/api_2_0');
    }

    deleteToken() {
        return new Request(this,'Delete','company/'+gd.companyId+'/admin/api_2_0');
    }

    deleteWebhook(companyId, webhookId) {
        return new Request(this,'Delete','company/'+gd.companyId+'/admin/api_2_0/webhook/'+webhookId);
    }

    createWebhook(companyId, projectId, endpointUrl, actions, recursive, secret) {
        return new Request(this,'POST','company/'+gd.companyId+'/admin/api_2_0/webhooks',{
            projectId, endpointUrl, actions, recursive, secret
        });
    }

    activateWebhook(companyId, webhookId) {
        return new Request(this,'POST','company/'+gd.companyId+'/admin/api_2_0/webhook/'+webhookId);
    }

    updateWebhook(companyId, webhookId, projectId, endpointUrl, actions, recursive, secret) {
        return new Request(this,'PUT','company/'+gd.companyId+'/admin/api_2_0/webhook/'+webhookId, {
            projectId, endpointUrl, actions, recursive, secret
        });
    }

}


export default ApiCompanyApiV2;